import TenantManager from "../../managers/TenantManager";
import FileImporter from "../import_export/import/steps/FileImporter";
import FinishPayroll from "./FinishPayroll";
import PayrollGrid from "./PayrollGrid";
import ProcessPayrollGrid from "./ProcessPayrollGrid";

export default class PayrollStepsManager {

    static getQueryParam(location, param) {
        if (location?.search && param) {
            const query = new URLSearchParams(location.search);
            return query.get(param);
        }

        return null;
    }

    static getAllCreationSteps(onClickHandler, isContractor) {
        const payrunCriteria = TenantManager.getPeopleTenantData()?.payrunCalcCriteria;
        return [
          {
            title: `${
              isContractor ? "Select Contractors" : "Select Employees"
            }`,
            requiredProps: [],
            reqError: {
              ["invalidProfiles"]:
                "Some of the employee(s) have incomplete profiles. Please update their profiles to proceed.",
              ["isInvalid"]:
                "Some of the employee(s) have incomplete profiles. Please update their profiles to proceed.",
              ["invalidUnpaidDays"]:
                "Some of the employee(s) have unpaid days greater than work period. Please update their unpaid days to proceed.",
              ["negativeUnpaidDays"]:
                "Some of the employee(s) have negative unpaid days. Please update their unpaid days to proceed.",
              ["isFixedAllowanceNegative"]:
                "Some of the payroll(s) have negative fixed allowance. Please get the attendance filled or adjust other fixed components before proceeding."
            },
            getChild: (props) => (
              <ProcessPayrollGrid
                {...props}
                key={"1"}
                payrunId={props.payrollId}
                fileInfo={props.state.fileInfo}
                setData={props.setData}
                onStoreDataUpdate={props.handleCallback}
                isAction={true}
                isContractor={props.isContractor}
              />
            ),
            onClick: (event) => onClickHandler(event, 0),
          },

          {
            title: "Ready For Processing",
            requiredProps: ["invalidProfiles", "isInvalid", "invalidUnpaidDays", "negativeUnpaidDays", "isFixedAllowanceNegative"],
            reqError: "",
            getChild: (props) => (
              <ProcessPayrollGrid
                {...props}
                key={"2"}
                payrunId={props.payrollId}
                fileInfo={props.state.fileInfo}
                setData={props.setData}
                onStoreDataUpdate={props.handleCallback}
                isAction={false}
                isContractor={props.isContractor}
              />
            ),
            onClick: (event) => onClickHandler(event, 1),
          },
          {
            title: "Payroll Processed",
            requiredProps: [],
            reqError: "",
            getChild: (props) => (
              <FinishPayroll
                {...props}
                payrunId={props.payrollId}
                isAction={false}
                key={"3"}
                isContractor={props.isContractor}
                // {...props.state}
                // setData={props.setData}
                // tableName={props.tableName}
                // backStepHandler={(e) => onClickHandler(e, 1)}
                // confirmationHandler={(e) => onClickHandler(e, 3)}
                // segmentValues={StepsManager.getSegmentColumn(props.tableName)}
                // getTableColumns={StepsManager.getColumns}
              />
            ),
            onClick: (event) => onClickHandler(event, 2),
          },
        ];
    }

    static getProcessedPayrollData( payrollData, payrollId) {
        let inProcessPayroll = {};
        let payruns = payrollData && payrollData.payruns ? payrollData.payruns : []
        if(payruns && payruns.length > 0) {
            let filteredPayroll = payruns.filter(payrun => payrun._id === payrollId);
            if (filteredPayroll && filteredPayroll.length > 0) {
                inProcessPayroll = filteredPayroll[0];
            }
        }
        return inProcessPayroll;
    }
}
